import { useLingui } from "@lingui/react/macro";
import { useMemo } from "react";
import z from "zod";

export function useLoginFormSchema() {
  const { t } = useLingui();

  return useMemo(() => {
    return z.object({
      username: z.email({
        error: t`Vänligen ange din e-postadress`,
      }),
      password: z.string({
        error: t`Vänligen ange ett lösenord`,
      }),
    });
  }, [t]);
}
